import { render } from "./wcSectionView.vue?vue&type=template&id=690883a4"
import script from "./wcSectionView.vue?vue&type=script&lang=js"
export * from "./wcSectionView.vue?vue&type=script&lang=js"

import "./wcSectionView.vue?vue&type=style&index=0&id=690883a4&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__